// v2/hooks/useResponsive.ts — Responsive breakpoint hook

import { useState, useEffect } from 'react';

interface ResponsiveState {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

function getResponsiveState(width: number): ResponsiveState {
  return {
    isMobile: width < 768,
    isTablet: width >= 768 && width <= 1024,
    isDesktop: width > 1024,
  };
}

/**
 * Returns responsive breakpoint flags based on viewport width.
 * - isMobile: width < 768px
 * - isTablet: 768px–1024px
 * - isDesktop: > 1024px
 */
export function useResponsive(): ResponsiveState {
  const [state, setState] = useState<ResponsiveState>(() =>
    getResponsiveState(window.innerWidth)
  );

  useEffect(() => {
    const handleResize = () => {
      setState(getResponsiveState(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return state;
}
